import { createRouter, createWebHistory } from 'vue-router';

import auth from '@/middleware/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/components/pages/PageHomeDashboard.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '',
        accessibility: {
          currentPage: {
            sk: 'úvod',
            en: 'dashboard',
          },
        },
      },
    },
    {
      path: '/zmena-hesla',
      name: 'changePassword',
      component: () =>
        import('@/components/pages/changepassword/PageChangePassword.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/zmena-hesla',
        accessibility: {
          currentPage: {
            sk: 'zmena hesla',
            en: 'change password',
          },
        },
      },
    },
    {
      path: '/alias',
      name: 'alias',
      component: () => import('@/components/pages/alias/PageAlias.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/alias',
        accessibility: {
          currentPage: {
            sk: 'zmena aliasu',
            en: 'change of alias',
          },
        },
      },
    },
    {
      path: '/sporopay-kluc',
      name: 'sporopayKey',
      component: () =>
        import('@/components/pages/sporopaykey/PageSporopayKey.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/sporopay-kluc',
        accessibility: {
          currentPage: {
            sk: 'sporopay klúč',
            en: 'sporopay key',
          },
        },
      },
    },
    {
      path: '/bezpecnostne-predmety',
      name: 'authTools',
      component: () =>
        import('@/components/pages/authtools/PageAuthToolsDashboard.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/bezpecnostne-predmety',
        accessibility: {
          currentPage: {
            sk: 'bezpečnostné predmety',
            en: 'authentication tools',
          },
        },
      },
    },
    {
      path: '/bezpecnostne-predmety/eok',
      name: 'eok',
      component: () => import('@/components/pages/authtools/eok/PageEok.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/bezpecnostne-predmety',
        accessibility: {
          currentPage: {
            sk: 'detail eok',
            en: 'detail eok',
          },
        },
      },
    },
    {
      path: '/bezpecnostne-predmety/epin/edit',
      name: 'epinEdit',
      component: () =>
        import('@/components/pages/authtools/epin/PageEpinEdit.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/bezpecnostne-predmety',
        accessibility: {
          currentPage: {
            sk: 'editácia epinu',
            en: 'epin edit',
          },
        },
      },
    },
    {
      path: '/bezpecnostne-predmety/sms-kluc',
      name: 'smsKey',
      component: () =>
        import('@/components/pages/authtools/smsKey/PageSmsKey.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/bezpecnostne-predmety',
        accessibility: {
          currentPage: {
            sk: 'detail sms kľúča',
            en: 'detail of sms key',
          },
        },
      },
    },
    {
      path: '/bezpecnostne-predmety/mtoken/edit',
      name: 'mTokenEdit',
      component: () =>
        import('@/components/pages/authtools/mtoken/PageMtokenEdit.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/bezpecnostne-predmety',
        accessibility: {
          currentPage: {
            sk: 'editácia mtokenu',
            en: 'mtoken edit',
          },
        },
      },
    },
    {
      path: '/tpp',
      name: 'tpp',
      component: () => import('@/components/pages/tpp/PageTppDashboard.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/tpp',
        accessibility: {
          currentPage: {
            sk: 'Aplikácie tretích strán',
            en: 'Third party applications',
          },
        },
      },
    },
    // {
    //     path: '/tpp/history',
    //     name: 'tppHistory',
    //     component: () => import('@/components/pages/tpp/PageTppHistory.vue'),
    //     meta: {
    //         middleware: [auth],
    //         secvReturn: '/tpp',
    //         accessibility: {
    //             currentPage: {
    //                 sk: 'Aplikácie tretích strán - História',
    //                 en: 'Third party applications - History',
    //             },
    //         },
    //     },
    // },
    {
      path: '/tpp/edit',
      name: 'tppEdit',
      component: () => import('@/components/pages/tpp/PageTppEdit.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/tpp',
        accessibility: {
          currentPage: {
            sk: 'Aplikácie tretích strán - Editácia',
            en: 'Third party applications - Editácia',
          },
        },
      },
    },
    {
      path: '/signing',
      name: 'signing',
      component: () => import('@/components/pages/utility/PageSigning.vue'),
      meta: {
        middleware: [auth],
        secvReturn: '/bezpecnostne-predmety',
        accessibility: {
          currentPage: {
            sk: 'Overenie podpisom',
            en: 'Sign verification',
          },
        },
      },
    },
    {
      path: '/overenie-sms',
      name: 'smsVerification',
      component: () =>
        import('@/components/pages/smsVerification/PageSmsVerification.vue'),
      meta: {
        secvReturn: '/overenie-sms',
        accessibility: {
          currentPage: {
            sk: 'Overenie web linku',
            en: 'Web link verification',
          },
        },
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/components/pages/utility/PageNotFound.vue'),
      meta: {
        secvReturn: '',
        accessibility: {
          currentPage: {
            sk: 'nenájdená stránka',
            en: 'page not found',
          },
        },
      },
    },
  ],
});

// middleware next factory
function nextFactory(context: any, middleware: any[], index: number) {
  const subsequentMiddleware = middleware[index];

  // if no subsequent Middleware exists,  the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters: any[]) => {
    // run the default next() callback first.
    context.next(...parameters);
    // than run the subsequent Middleware with a new nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

// global callback
router.beforeEach((to, from, next) => {
  // MIDDLEWARE
  // check if we have some mw on route
  if (to?.meta?.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    // prepare context
    const context = {
      from,
      next,
      router,
      to,
    };

    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

router.afterEach((to, from) => {
  console.log(`Routing: ${from.name} -> ${to.name}`);
});

export default router;
